import useMutationApi from '../useMutationApi';
import { QuoteSheetLineItemDTO } from './quote-sheets-types';

interface ConfirmQuoteSheetMatchRequest {
  lineItemId: string;
  productId?: string;
  productVariantId?: string;
  supplierProductId?: string;
}

interface ConfirmQuoteSheetMatchResponse {
  success: boolean;
  data?: QuoteSheetLineItemDTO;
  error?: string;
}

export function useConfirmQuoteSheetMatch() {
  return useMutationApi<
    ConfirmQuoteSheetMatchRequest,
    ConfirmQuoteSheetMatchResponse
  >({
    endpoint: 'accounts-payable/quote-sheet-matching/confirm-match',
    method: 'POST',
    successMessage: 'Match confirmed successfully',
    errorMessage: 'Failed to confirm match',
    showSuccessToast: true,
    showErrorToast: true,
  });
}
